module.exports = __webpack_public_path__ + "img/eight_classify.0d78c35a.png";